export default __webpack_public_path__ + "static/media/unchecked_simple.7ac55f6a.svg";